<template>
    <div>{{ contact }}</div>
</template>

<script>
    export default{
        name:'ContactPage',
        computed:{
            contact(){
                return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.contact : 'Contact';
            }
        }
    }
</script>